var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input',{staticClass:"pa-1",style:(_vm.perPageFieldWidth),attrs:{"min":"1","type":"number"},domProps:{"textContent":_vm._s(_vm.perPage)},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=_vm._n($$v)},expression:"perPage"}})}
var staticRenderFns = []

export { render, staticRenderFns }